export function getPricingURL(instanceId) {
  return 'https://crmcanis.com/licenca/' + instanceId + '/'
}
